export const NOT_ENOUGH_FUNDS = 'NOT_ENOUGH_FUNDS';
export const USER_DENIED = 'USER_DENIED';
export const USER_REJECTED = 'user_rejected';
export const SLIPPAGE = 'SLIPPAGE';
export const RPC_ERROR = 'RPC_ERROR';
export const PAUSED = 'PAUSED';
export const MAX_TRADES_PER_PAIR = 'MAX_TRADES_PER_PAIR';
export const MAX_PENDING_ORDERS = 'MAX_PENDING_ORDERS';
export const ABOVE_MAX_POS = 'ABOVE_MAX_POS';
export const BELOW_MIN_POS = 'BELOW_MIN_POS';
export const LEVERAGE_INCORRECT = 'LEVERAGE_INCORRECT';
export const NO_CORRESPONDING_NFT_SPREAD_REDUCTION =
  'NO_CORRESPONDING_NFT_SPREAD_REDUCTION';
export const WRONG_TP = 'WRONG_TP';
export const WRONG_SL = 'WRONG_SL';
export const PRICE_IMPACT_TOO_HIGH = 'PRICE_IMPACT_TOO_HIGH';
export const ALREADY_BEING_CLOSED = 'ALREADY_BEING_CLOSED';
export const NO_TRADE = 'NO_TRADE';
export const NO_LIMIT = 'NO_LIMIT';
export const LIMIT_TIMELOCK = 'LIMIT_TIMELOCK';
export const SL_TOO_BIG = 'SL_TOO_BIG';

type ErrorPattern = { msg?: string; code?: number };

const TX_ERROR_PATTERNS: { [key: string]: ErrorPattern[] } = {
  [NOT_ENOUGH_FUNDS]: [
    { msg: 'not enough funds for gas' },
    { msg: 'failed to execute call with revert code InsufficientGasFunds' },
  ],

  [USER_REJECTED]: [{ msg: 'User Rejected' }],
  [USER_DENIED]: [{ msg: 'User denied transaction signature' }],
  [SLIPPAGE]: [
    { msg: 'Router: mark price lower than limit' },
    { msg: 'Router: mark price higher than limit' },
  ],
  [RPC_ERROR]: [
    // @see https://eips.ethereum.org/EIPS/eip-1474#error-codes
    { code: -32005 },
    { msg: 'Non-200 status code' },
    { msg: 'Request limit exceeded' },
    { msg: 'Internal JSON-RPC error' },
    { msg: 'Response has no error or result' },
    { msg: "couldn't connect to the network" },
  ],
  [PAUSED]: [{ msg: 'Contract is temporarily suspended' }],
  [MAX_TRADES_PER_PAIR]: [{ msg: 'Max trades per pair reached' }],
  [MAX_PENDING_ORDERS]: [{ msg: 'Max pending orders' }],
  [ABOVE_MAX_POS]: [{ msg: 'Trade above max collateral' }],
  [BELOW_MIN_POS]: [{ msg: 'Trade below min position' }],
  [LEVERAGE_INCORRECT]: [{ msg: 'Leverage incorrect' }],
  [NO_CORRESPONDING_NFT_SPREAD_REDUCTION]: [
    { msg: 'No corresponding NFT spread reduction' },
  ],
  [WRONG_TP]: [{ msg: 'Wrong take profit' }],
  [WRONG_SL]: [{ msg: 'Wrong stop loss' }],
  [PRICE_IMPACT_TOO_HIGH]: [{ msg: 'Price impact too high' }],
  [ALREADY_BEING_CLOSED]: [{ msg: 'Trade already being closed' }],
  [NO_TRADE]: [{ msg: `Trade doesn't exist` }],
  [NO_LIMIT]: [{ msg: `Limit trade doesn't exist` }],
  [LIMIT_TIMELOCK]: [{ msg: `Limit timelock` }],
  [SL_TOO_BIG]: [{ msg: `Stop loss too big` }],
};

type TxError = {
  message?: string;
  code?: number;
  data?: any;
};

export function extractError(ex: TxError) {
  if (!ex) {
    return [];
  }

  const message = ex.data?.message || ex.message;
  const code = ex.code;
  if (!message && !code) {
    return [];
  }
  for (const [type, patterns] of Object.entries(TX_ERROR_PATTERNS)) {
    for (const pattern of patterns) {
      const matchCode = pattern.code && code === pattern.code;

      const matchMessage =
        pattern.msg &&
        message &&
        (message.includes(pattern.msg) || message.includes(type));

      if (matchCode || matchMessage) {
        return [pattern.msg, type, ex.data];
      }
    }
  }

  return [message, null, ex.data];
}
